import { Play } from "lucide-react";

export function MediaPreview({ item, className = "", hoverScale = false }) {
  const isVideo = item.media_type === "video";
  const isExternal = item.media_url?.startsWith("http");

  if (isVideo && isExternal) {
    return (
      <a href={item.media_url} target="_blank" rel="noopener noreferrer" className={`w-full h-full flex items-center justify-center bg-black/80 ${className}`} onClick={e => e.stopPropagation()}>
        <Play size={48} className="text-white/80" />
      </a>
    );
  }

  if (isVideo) {
    return <video src={item.media_url} className={`w-full h-full object-cover ${className}`} preload="metadata" />;
  }

  return (
    <img
      src={item.media_url}
      alt={item.title}
      className={`w-full h-full object-cover ${hoverScale ? "group-hover:scale-105 transition-transform duration-500" : ""} ${className}`}
    />
  );
}

export function MediaPreviewSmall({ item, className = "" }) {
  const isVideo = item.media_type === "video";
  const isExternal = item.media_url?.startsWith("http");

  if (isVideo && isExternal) {
    return (
      <div className={`w-full h-full flex items-center justify-center bg-black/5 ${className}`}>
        <a href={item.media_url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2 text-[#C4392D] hover:text-[#E8922F] transition-colors">
          <Play size={40} />
          <span className="text-xs font-medium">Watch Video</span>
        </a>
      </div>
    );
  }

  if (isVideo) {
    return <video src={item.media_url} className={`w-full h-full object-cover ${className}`} controls preload="metadata" />;
  }

  return <img src={item.media_url} alt={item.title} className={`w-full h-full object-cover ${className}`} />;
}
